var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 29,
    viewBox: "0 0 23 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7109 25.5742H0.289062C0.138672 25.5742 0.015625 25.6973 0.015625 25.8477V27.8984C0.015625 28.0488 0.138672 28.1719 0.289062 28.1719H22.7109C22.8613 28.1719 22.9844 28.0488 22.9844 27.8984V25.8477C22.9844 25.6973 22.8613 25.5742 22.7109 25.5742ZM22.7109 0.828125H0.289062C0.138672 0.828125 0.015625 0.951172 0.015625 1.10156V3.15234C0.015625 3.30273 0.138672 3.42578 0.289062 3.42578H22.7109C22.8613 3.42578 22.9844 3.30273 22.9844 3.15234V1.10156C22.9844 0.951172 22.8613 0.828125 22.7109 0.828125ZM14.877 9.91992C15.082 9.91992 15.1982 9.68066 15.0718 9.52002L11.6265 5.15869C11.6037 5.12918 11.5744 5.10529 11.5409 5.08885C11.5074 5.07241 11.4706 5.06386 11.4333 5.06386C11.3961 5.06386 11.3593 5.07241 11.3258 5.08885C11.2923 5.10529 11.263 5.12918 11.2402 5.15869L7.79492 9.52002C7.76622 9.55651 7.74837 9.60035 7.74343 9.64651C7.7385 9.69268 7.74666 9.7393 7.76699 9.78103C7.78733 9.82277 7.81901 9.85794 7.8584 9.8825C7.8978 9.90706 7.94332 9.92003 7.98975 9.91992H10.2695V19.0801H8.12305C7.91797 19.0801 7.80176 19.3193 7.92822 19.48L11.3735 23.8379C11.4727 23.9644 11.6641 23.9644 11.7598 23.8379L15.2051 19.48C15.3315 19.3193 15.2188 19.0801 15.0103 19.0801H12.7305V9.91992H14.877Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIHeight);
export default __webpack_public_path__ + "static/media/iHeight.c65631e681f7a22b294735735b675592.svg";
export { ForwardRef as ReactComponent };